import axios from 'axios';
import { API_URL } from '../common/enum'

const URL = API_URL.HOST + '/coopration';

export const apiCoopration = {
    getAllTmp(token: any) {
        return axios.get(`${URL}/tmp`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },
    getAll(token: any) {
        return axios.get(`${URL}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },
    getAllTmpByUserId(userId: any, token: any) {
        return axios.get(`${URL}/tmp/user/${userId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

    },
    getAllByUserId(userId: any, token: any) {
        return axios.get(`${URL}/user/${userId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    createCooperation(expert: any, token: any) {
        return axios.post(`${URL}`, expert,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },
    getCooperationById(id: any, token: any) {
        return axios.get(`${URL}/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    updateCooperation(expert: any, token: any) {
        const { id, ...payload } = expert;
        return axios.put(`${URL}/${id}`, payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    deleteCooperation(id: any, token: any) {
        return axios.delete(`${URL}/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    changeStatus(expert: any, token: any) {
        const { id, ...payload } = expert;
        return axios.put(`${URL}/changeStatus/${id}`, payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    uploadFile(file: FormData, token: any) {
        return axios.post(`${URL}/file/addFile`, file, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    updateFile(cooprationId: string, file: FormData, token: any) {
        return axios.put(`${URL}/file/updateFile/${cooprationId}`, file, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    getAllFile(token: any) {
        return axios.get(`${URL}/file/allFile`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    getFileByCooprationId(cooprationId: string, token: any) {
        return axios.get(`${URL}/file/byCooprationId/${cooprationId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    downloadFile(fileName: string, token: any) {
        return axios.get(`${URL}/file/download/${encodeURIComponent(fileName)}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
            responseType: 'blob'
        });
    }

};
